import React from 'react';

import { useAppContext, useDeepEffect } from '../../hooks';

type DynamicPageTitleProps = {
  children: React.ReactNode;
};

const DynamicPageTitle: React.FC<DynamicPageTitleProps> = ({ children }) => {
  const { addTitle, removeTitle } = useAppContext();

  useDeepEffect(() => {
    return addTitle(children);
  }, [children, addTitle, removeTitle]);

  return null;
};

export default React.memo(DynamicPageTitle) as typeof DynamicPageTitle;
